<head>

<script src="https://unpkg.com/vue"></script>
<script src="https://unpkg.com/vue-cal"></script>
<link href="https://unpkg.com/vue-cal/dist/vuecal.css" rel="stylesheet">
</head>
<template>
  <a-card title="Listar Refeições">
    <div class="row" style="margin-bottom: 1%">
      <div class="col-md-9">
        <label for="cpf">Descrição</label>
        <div class="input-group input-focus">
          <input type="text" class="form-control form-input-component" v-model="nome" ref="nome" />
        </div>
      </div>
      <div class="col-md-3">
        <label for="cpf">Status</label>

        <div class="input-group input-focus">
          <select v-model="situacao" class="form-select form-input-component">
            <option value="TODOS">Todos</option>
            <option value="ATIVO">Ativo</option>
            <option value="INATIVO">Inativo</option>
          </select>
        </div>
      </div>
    </div>
    <a-divider type="horizontal" />
    <div class="row">
      <div class="col-md-4" style="margin-bottom: 0.3%">
        <button @click="pesquisar()" class="btn btn-primary" type="button"><i class="fa fa-search"> </i> Pesquisar</button>
        <button type="button" class="btn btn-primary" @click="criarNova" style="margin: 0 5px">
          <i class="fa fa-plus"> </i>
          Criar novo
        </button>
      </div>
    </div>
  </a-card>
  <br />
  <a-card>
    <a-table :dataSource="lista" :columns="columns" :pagination="paginationConfig">
      <template #situacao="{ record }">
        <a-switch :checked="record.situacao === 'ATIVO'" @change="toggleSituacao(record)" />
      </template>
      <template #action="{ record }">
        <a title="Excluir" @click="excluirRefeicao(record)"><i class="fas fa-trash icon-trash"></i></a>
        &nbsp;&nbsp;
        <a title="Editar" @click="editarRefeicao(record)"><i class="fas fa-edit icon-edit"></i></a>
      </template>
    </a-table>
  </a-card>
</template>

<script>
import { openNotification, typesNotification } from '@/utils/notifications';
import { deleteRefeicaoById, getListaRefeicoes, createRefeicao } from '@/components/service/refeicaoService';

export default {
  name: 'PageListarRefeicao',
  data() {
    return {
      situacao: 'TODOS',
      nome: undefined,
      lista: [],
      paginationConfig: {
        pageSize: 10, // Define o número de itens por página
        total: 0, // Total de itens no dataSource
      },
      columns: [
        {
          title: 'Descrição',
          dataIndex: 'nome',
          key: 'nome',
          slots: { customRender: 'descrição' },
        },
        {
          title: 'Status',
          dataIndex: 'situacao',
          key: 'situacao',
          slots: { customRender: 'situacao' },
        },
        {
          title: 'Ações',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
  methods: {
    excluirRefeicao(record) {
      deleteRefeicaoById(record.id)
        .then(() => {
          openNotification(typesNotification.success, 'Refeição excluída com sucesso.');
          this.pesquisar();
        })
        .catch(() => {
          openNotification(typesNotification.error, 'Falha ao excluir refeição!');
        });
    },
    editarRefeicao(record) {
      this.$router.push({ path: '/form-refeicao', query: { id: record.id } });
    },
    criarNova() {
      this.$router.push('form-refeicao');
    },

    async toggleSituacao(refeicao) {
      const novoStatus = refeicao.situacao === 'ATIVO' ? 'INATIVO' : 'ATIVO';
      const novaRefeicao = { ...refeicao, situacao: novoStatus };
      await createRefeicao(novaRefeicao);
      this.lista.find((i) => i.id == refeicao.id).situacao = novoStatus;
      openNotification(typesNotification.success, 'Status da refeição alterado com sucesso!');
    },
    async pesquisar() {
      var filtros = { nome: this.nome, situacao: this.situacao };
      getListaRefeicoes(filtros)
        .then((r) => {
          if (r.data.length > 0) {
            this.lista = r.data;
          } else {
            openNotification(typesNotification.info, 'Nenhum registro encontrado para os dados informados na pesquisa!');
            this.lista = r.data;
          }
        })
        .catch(() => {
          openNotification(typesNotification.error, 'Falha ao recuperar a lista de refeições cadastrados!');
        });
    },
  },
  created() {
    this.pesquisar();
  },
};
</script>

<style>
.input-group-text {
  height: 38px;
}

.input-group-prepend {
  cursor: pointer;
  margin-left: 8px !important;
}

.input-group-text:hover {
  background-color: #e0e0e0 !important;
}

.h2 {
  font-size: x-large;
}
</style>
